import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, NavLink, Outlet } from 'react-router-dom';
import ArtavaAttribution from '../../components/artava/ArtavaAttribution';
import { artavaBrand } from '../../branding/artavaBrand';
import { useSmartiLabContext } from './SmartiLabContext';
import LabInfoHelp from './components/LabInfoHelp';
import SmartiLabIcon from './components/SmartiLabIcon';
import SmartiLabShell from './components/SmartiLabShell';
import SmartiLabTrustPanel from './components/SmartiLabTrustPanel';
import { smartiLabHelpCopy } from './content/smartiLabHelpCopy';
import './styles/smartiLabTheme.css';
import './styles/smartiLab.css';

export default function SmartiLabLayout() {
  const { i18n } = useTranslation();
  const {
    isAdmin,
    scope,
    setScope,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    trustSnapshot,
  } = useSmartiLabContext();
  const isItalian = i18n.language !== 'en';
  const navItems = [
    { to: '/smarti-lab', label: isItalian ? 'Panoramica' : 'Overview', end: true },
    { to: '/smarti-lab/executive', label: isItalian ? 'Executive' : 'Executive' },
    { to: '/smarti-lab/units', label: isItalian ? 'Storico unità' : 'Unit history' },
    { to: '/smarti-lab/root-cause', label: isItalian ? 'Root cause' : 'Root cause' },
    { to: '/smarti-lab/cross-dataset-links', label: isItalian ? 'Link workbench' : 'Link workbench' },
    { to: '/smarti-lab/cases', label: isItalian ? 'Casi' : 'Cases' },
    { to: '/smarti-lab/compare', label: isItalian ? 'Compare' : 'Compare' },
    { to: '/smarti-lab/ops', label: isItalian ? 'Ops' : 'Ops' },
  ];

  return (
    <SmartiLabShell>
      <aside className="lab-sidebar">
        <div className="lab-sidebar-brand">
          <span className="lab-badge">{isItalian ? 'Solo ML' : 'ML only'}</span>
          <div className="lab-title-row">
            <span className="lab-brand-icon"><SmartiLabIcon compact /></span>
            <h1>Smarti Lab</h1>
            <LabInfoHelp compact ariaLabel="Spiegazione Smarti Lab / Smarti Lab explanation" {...smartiLabHelpCopy.overview} />
          </div>
          <p>{isItalian ? 'Indagine machine-learning su dati di produzione e burn-in, focalizzata su evidenze, confidenza e priorità di indagine.' : 'Machine-learning investigation on production and burn-in data, focused on evidence, confidence, and investigation priority.'}</p>
        </div>
        <nav className="lab-nav">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) => `lab-nav-link${isActive ? ' active' : ''}`}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="lab-sidebar-actions">
          <Link to="/production-dashboard" className="lab-button ghost">{isItalian ? 'Apri dashboard produzione' : 'Open production dashboard'}</Link>
          <Link to="/burn-in-dashboard" className="lab-button ghost">{isItalian ? 'Apri dashboard burn-in' : 'Open burn-in dashboard'}</Link>
          <Link to="/support/artava" className="lab-button ghost">{isItalian ? 'Artava e supporto' : 'Artava and support'}</Link>
          <Link to="/dashboard" className="lab-button">{isItalian ? 'Torna al selettore' : 'Back to selector'}</Link>
        </div>
        <div className="lab-brand-footer">
          <ArtavaAttribution variant="compact" />
          <a href={artavaBrand.websiteUrl} target="_blank" rel="noreferrer" className="lab-brand-link">
            {artavaBrand.websiteHost}
          </a>
        </div>
      </aside>
      <main className="lab-main">
        <div className="lab-banner">
          {isItalian
            ? 'Smarti Lab mostra evidenze di indagine e flag di cautela. Non prova automaticamente la causa finale.'
            : 'Smarti Lab shows investigation evidence and caution flags. It does not automatically prove the final cause.'}
        </div>
        <SmartiLabTrustPanel trust={trustSnapshot} compact />
        <div className="lab-filter-bar">
          <div className="lab-filter-fields">
            {isAdmin ? (
              <select className="lab-input" value={scope} onChange={(event) => setScope(event.target.value)}>
                <option value="mine">{isItalian ? 'Scope: i miei dati' : 'Scope: my data'}</option>
                <option value="all">{isItalian ? 'Scope: tutti i dati' : 'Scope: all data'}</option>
              </select>
            ) : null}
            <input className="lab-input" type="date" value={startDate} onChange={(event) => setStartDate(event.target.value)} />
            <input className="lab-input" type="date" value={endDate} onChange={(event) => setEndDate(event.target.value)} />
          </div>
        </div>
        <Outlet />
      </main>
    </SmartiLabShell>
  );
}
